module.exports = __webpack_public_path__ + "img/napa_green_winery.6231b24f.jpg";